// initial state
export const INITIAL_STATE = {
    pageTitle: "",
    isLoggedIn: null,
    isAdminLoggedIn: false,
    user: null,
    pageHead: "",
    isActivePageSpinner: true,
};